import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "utils"
}
const _hoisted_2 = {
  key: 1,
  class: "quotedMessage"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "timestamp" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["chatMessage", { right: _ctx.message.senderIdentifier == _ctx.userId, left: _ctx.message.senderIdentifier != _ctx.userId, selected: _ctx.flagged }])
  }, [
    (_ctx.canRemove)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-danger",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitRemove && _ctx.emitRemove(...args)))
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "fa fa-remove" }, null, -1)
          ]))
        ]))
      : _createCommentVNode("", true),
    (_ctx.message.quotedMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", {
            class: _normalizeClass(["sender", {'text-green': _ctx.message.fromBackend}])
          }, _toDisplayString(_ctx.message.quotedMessage.sender), 3),
          _createElementVNode("span", {
            innerHTML: _ctx.message.quotedMessage.text
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_router_link, {
        to: '/lead/detail/' + _ctx.message.senderIdentifier + '/visualizza',
        class: _normalizeClass(["sender", {'text-green': _ctx.message.fromBackend}])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.message.sender), 1)
        ]),
        _: 1
      }, 8, ["to", "class"])
    ]),
    _createElementVNode("span", {
      innerHTML: _ctx.message.text,
      ref: "messageContainer"
    }, null, 8, _hoisted_4),
    _createElementVNode("small", _hoisted_5, _toDisplayString(_ctx.$filters.date(_ctx.message.timestamp, 'YYYY-MM-DD HH:mm')), 1)
  ], 2))
}